import { IColumn } from '@fluentui/react';
import { makeSpreadsheetItemList } from './makeSpreadsheetItemList';
import { makeWorkbookFromSheet } from './makeWorkbookFromSheet';

/** Converts Fluent Detailslist items to an excel workbook */
export const convertDetailslistToSheet = async <T = any>(
  columns: IColumn[],
  items: T[]
): Promise<import('exceljs').Workbook> => {
  const sheetItems = makeSpreadsheetItemList(items, columns);

  return makeWorkbookFromSheet(columns, sheetItems);
};
